import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./App";
import { store } from "./store/store";
import { PopoverProvider } from './context/PopoverContext';

ReactDOM.render(
    <Router>
        <Provider store={store}>
            <PopoverProvider>
                <App />
            </PopoverProvider>
        </Provider>
    </Router>
    , document.getElementById("root")
);
